import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import ProjectsSettingsPage, { pathToProjectsSettingsTab } from "@/components/settings/projects/projects-settings-page";

const ProjectsLayout = (): JSX.Element => {
	const tab = useRouterState({
		select: (state) =>
			pathToProjectsSettingsTab(state.location.pathname) ??
			(state.resolvedLocation ? pathToProjectsSettingsTab(state.resolvedLocation.pathname) : null),
	});
	if (!tab) {
		return <Outlet />;
	}
	return (
		<ProjectsSettingsPage tab={tab}>
			<Outlet />
		</ProjectsSettingsPage>
	);
};

export const Route = createFileRoute("/_app/settings/projects")({
	component: ProjectsLayout,
});
